import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { IconEditCustom, IconDelete } from '@sfx/icons';
import TableView from '../../../Basic/TableView';

var CellActions = function CellActions(_ref) {
  var row = _ref.row,
      handleEdit = _ref.handleEdit,
      handleDel = _ref.handleDel;
  var original = row.original;
  return /*#__PURE__*/React.createElement("div", {
    className: 'cellActions'
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return handleEdit(original);
    }
  }, /*#__PURE__*/React.createElement(IconEditCustom, {
    size: 18,
    style: {
      marginRight: '17px',
      cursor: 'pointer'
    }
  })), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return handleDel(original);
    }
  }, /*#__PURE__*/React.createElement(IconDelete, {
    size: 18,
    style: {
      marginRight: '17px',
      cursor: 'pointer'
    }
  })));
};

export var PlantManagementTable = /*#__PURE__*/function (_Component) {
  _inherits(PlantManagementTable, _Component);

  var _super = _createSuper(PlantManagementTable);

  function PlantManagementTable() {
    var _this;

    _classCallCheck(this, PlantManagementTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      columns: []
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.initColumns();
    });

    _defineProperty(_assertThisInitialized(_this), "initColumns", function () {
      var columns = [{
        id: 'Name',
        isFilterable: false,
        isSortable: true,
        accessor: function accessor(row) {
          return row.Name;
        },
        Header: _this.props.translate('SFxAccountSettingsPlantTableNameTitle'),
        headerStyle: {
          minWidth: 150,
          paddingLeft: '10px'
        },
        style: {
          minWidth: 150,
          paddingLeft: '8px'
        },
        minWidth: 150,
        Cell: function Cell(row) {
          return /*#__PURE__*/React.createElement("div", {
            className: "lh30"
          }, row.original.Name || '--');
        }
      }, {
        id: 'Address',
        isFilterable: false,
        isSortable: true,
        Header: _this.props.translate('SFxAccountSettingsPlantTableAddressTitle'),
        accessor: function accessor(row) {
          return row.Address;
        },
        headerStyle: {
          minWidth: 180
        },
        style: {
          minWidth: 180
        },
        minWidth: 180,
        Cell: function Cell(row) {
          return /*#__PURE__*/React.createElement("div", {
            className: "lh30"
          }, row.original.Address || '--');
        }
      }, {
        id: '_actions',
        isFilterable: false,
        isSortable: false,
        headerStyle: {
          minWidth: 80
        },
        style: {
          minWidth: 80,
          padding: 5
        },
        minWidth: 80,
        className: 'disable-resize',
        headerClassName: 'disable-resize',
        Cell: function Cell(row) {
          return /*#__PURE__*/React.createElement(CellActions, {
            row: row,
            handleEdit: _this.props.handleEdit,
            handleDel: _this.props.handleDel
          });
        }
      }];

      _this.setState({
        columns: columns
      });
    });

    return _this;
  }

  _createClass(PlantManagementTable, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TableView, _extends({}, this.props, {
        className: 'plantManagementTable',
        columns: this.state.columns,
        data: this.props.plantList
      }));
    }
  }]);

  return PlantManagementTable;
}(Component);
export default PlantManagementTable;